import React, { FC } from 'react'

import { ProfileNoImage } from 'components/block/ProfileNoImage/ProfileNoImage'
import { GQLPhotoItemFragment } from 'components/page/ForeignProfile/gql/__generated__/Photos'
import { GQLGender } from 'generated-graphql/graphql'

import { Photo } from './Photo'
import { PhotoMore } from './PhotoMore'
import { PhotosSlide } from './PhotosSlide'
import { PhotoWithoutSlide } from './PhotoWithoutSlide'

/**
 *
 * @param userId
 * @param gender
 * @param photos - портретные фото одно из которых main {portrait: true, main: true}
 * @param restPhotos - {portrait: false}
 * @returns
 */
export const Photos: FC<{
  userId: number
  gender: GQLGender
  incognito: boolean
  photos: GQLPhotoItemFragment[]
  restPhotos: GQLPhotoItemFragment[]
}> = ({ userId, gender, incognito, photos, restPhotos }) => {
  if (!photos.length && !restPhotos.length) {
    return (
      <PhotoWithoutSlide>
        <ProfileNoImage userId={userId} gender={gender} />
      </PhotoWithoutSlide>
    )
  }

  /**
   * Есть только одна главная
   */
  if (photos.length === 1 && !restPhotos.length) {
    const {
      photoId,
      width,
      height,
      urls: { huge, xHuge },
      faceCenter,
    } = photos[0]
    return (
      <PhotoWithoutSlide>
        <Photo
          key={photoId}
          photoId={photoId}
          xHuge={xHuge}
          huge={huge}
          width={width}
          height={height}
          incognito={incognito}
          coordinates={faceCenter ?? undefined}
        />
      </PhotoWithoutSlide>
    )
  }

  return (
    <PhotosSlide>
      {photos.length ? (
        photos.map(
          ({ photoId, width, height, urls: { huge, xHuge }, faceCenter }) => (
            <Photo
              key={photoId}
              photoId={photoId}
              xHuge={xHuge}
              huge={huge}
              width={width}
              height={height}
              incognito={incognito}
              coordinates={faceCenter ?? undefined}
            />
          )
        )
      ) : (
        <ProfileNoImage userId={userId} gender={gender} />
      )}
      {restPhotos.length > 0 && <PhotoMore photos={restPhotos} />}
    </PhotosSlide>
  )
}
